import React, { useEffect, useState } from 'react';
import { Justify, Form, Select, Button, Modal, Checkbox } from 'tea-component';
import { useIntl } from 'umi';
import identityProviderFun from '@/pages/home/utils/identityProviderFun';

export default function IdpListModal(props: any) {
  const { idpList, visible, onClose, onError = () => console.log } = props;
  const { formatMessage } = useIntl();

  // 密码
  const [selectIdp, setSelectIdp] = useState<string | null>(null);
  const [statusIdp, setStatusIdp] = useState(false);

  const onIdpBlurClick = () => {
    if (!selectIdp) {
      setStatusIdp(true);
    } else {
      setStatusIdp(false);
    }
  };


  return (
    <Modal
      visible={visible}
      onClose={onClose}
      caption={formatMessage({ id: 'dbh_login_type_sso' }, { type: 'SSO' })}
      className="idp-modal"
    >
      <Modal.Body>
        <Form>
          <Form.Item
            label={formatMessage({ id: 'dbi_company' })}
            status={statusIdp ? 'error' : undefined}
            message={
              statusIdp
                ? formatMessage({ id: 'dbh_login_choose_company_require' })
                : undefined
            }
          >
            <Select
              placeholder={formatMessage({
                id: 'dbh_login_choose_company_require',
              })}
              appearance="button"
              matchButtonWidth
              searchable
              size="full"
              tips={(selectedOptions) => {
                if (selectedOptions.length === 0) {
                  return formatMessage({ id: 'common_nodata' });
                } else {
                  return '';
                }
              }}
              value={selectIdp || ''}
              filter={(inputValue, option) => {
                return option?.company
                  ?.toLowerCase()
                  .includes(inputValue.toLowerCase());
              }}
              options={idpList}
              onChange={(val: any) => {
                setSelectIdp(val);
              }}
            />
          </Form.Item>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="primary"
          onClick={() => {
            onIdpBlurClick();
            if (selectIdp) {
              const { loginDomain, clientId, identityProvider, id } =
                JSON.parse(selectIdp);
              identityProviderFun({
                loginDomain,
                clientId,
                identityProvider,
                id,
              });
            }
          }}
        >
          {formatMessage({ id: 'common_confirm' })}
        </Button>
        <Button type="primary" onClick={onClose}>
          {formatMessage({ id: 'common_cancel' })}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
